<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>Menu Listing</h3>
    </div>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  menuData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : menuData.length
                }}
                of {{ menuData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD -->

        <vs-button type="gradient mr-4" v-on:click="addMenu()"
          >Add Menu</vs-button
        >
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          "
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        v-if="menuData"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="menuData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>

  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moment from "moment-timezone";

// Store Module
import moduleMenuManagement from "@/store/menu-management/moduleMenuManagement.js";
//import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import ls from "@/common/localStorage";

// Cell Renderer
// import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
// import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
// import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
// import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
// import CellRendererActionsReport from "./cell-renderer/CellRendererActionsReport.vue";
// import CellRendererPreviewActions from "./cell-renderer/CellRendererPreviewActions.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";

var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");

//console.log(db);

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    // CellRendererLink,
     CellRendererStatus,
    // CellRendererVerified,
    // CellRendererActions,
    // CellRendererActionsReport,
    // CellRendererPreviewActions,
    moment,
  },
  data() {
    return {
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],
      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],
      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],
      searchQuery: "",
      reportData: [],
      ReportSubject: null,
      DocName: null,
      CollectionName: null,
      popupActive: false,
      popupActive2: false,
      ClientDetails: null,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      gridOptions2: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs2: [
        {
          headerName: "From Email",
          field: "from_email",
          filter: true,
          width: 200,
        },
        {
          headerName: "Subject",
          field: "subject",
          filter: true,
          width: 300,
        },
        {
          headerName: "To Email",
          field: "to_email",
          filter: true,
          width: 200,
        },
        {
          headerName: "Status",
          field: "status",
          filter: true,
          //width: 100
        },
        {
          headerName: "Opens Count",
          field: "opens_count",
          filter: true,
          //width: 300
        },
        {
          headerName: "Clicks Count",
          field: "clicks_count",
          filter: true,
          //width: 300
        },
        {
          headerName: "Last Event Time",
          field: "last_event_time",
          cellRenderer: (data) => {
            return data.value
              ? this.SetTimeByZone(
                  new Date(data.value).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: true,
          width: 300,
        },
      ],
      columnDefs: [
        {
          headerName: "Menu ID",
          field: "MenuID",
          filter: true,
          width: 200,
        },
        {
          headerName: "Name",
          field: "Name",
          filter: true,
          width: 200,
        },
        {
          headerName: "Display Label",
          field: "DisplayLabel",
          filter: true,
          width: 200,
        },
        {
          headerName: "Page Url",
          field: "PageUrl",
          filter: true,
          width: 200,
        },
        {
          headerName: "Published",
          field: "IsPublished",
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
          cellRendererParams: (params) => {
            return {
              MenuID: params.data.MenuID,
              Name: params.data.Name,
              IsPublished: params.data.IsPublished,
            };
          },
        },
        // {
        //   headerName: "Edit",
        //   field: "transactions",
        //   width: 150,
        //   cellRendererFramework: "CellRendererActions",
        //   cellRendererParams: (params) => {
        //     return {
        //       DocName: params.data.DocName,
        //       CollectionName: params.data.CollectionName,
        //     };
        //   },
        // },
        // {
        //   headerName: "Preview",
        //   field: "transactions",
        //   width: 150,
        //   cellRendererFramework: "CellRendererPreviewActions",
        //   cellRendererParams: (params) => {
        //     return {
        //       DocName: params.data.DocName,
        //       CollectionName: params.data.CollectionName,
        //     };
        //   },
        // },
      ],

      // Cell Renderer Components
      components: {
        // CellRendererLink,
         CellRendererStatus,
        // CellRendererVerified,
        // CellRendererActions
      },
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
    menuData() {
      return this.$store.state.moduleMenuManagement.menu;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    fetchdeliveryReport() {
      this.$vs.loading();
      this.reportData = null;
      let Subject = this.ReportSubject;
      let DocName = this.DocName;
      let CollectionName = this.CollectionName;
      this.$store
        .dispatch("mailtplManagement/fetchdeliveryReport", {
          DocName: DocName,
          CollectionName: CollectionName,
          Subject: Subject,
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.data) this.reportData = res.data.result.messages;
        });
    },
    addMenu() {
      this.$router.push(`/menu/add`).catch(() => {});
    },
    // editRecord () {
    //   this.$router.push(`/event/exhibitor/add/${268}`).catch(() => {})
    // },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
          {
            label: "All",
            value: "all",
          };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    fetchClient() {
      this.$store
        .dispatch("clientManagement/fetchClient", Session_Client_Id)
        .then((res) => {
          if (res.status == 200) {
            this.ClientDetails = res.data;
            this.gridOptions.columnApi.setColumnVisible(
              "report",
              res.data.CustomSMTP ? false : true
            );
          }
        });
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;
    this.gridApi2 = this.gridOptions2.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleMenuManagement.isRegistered) {
      this.$store.registerModule("moduleMenuManagement", moduleMenuManagement);
      moduleMenuManagement.isRegistered = true;
    }
    this.$store.dispatch("moduleMenuManagement/fetchMenus").catch((err) => {
      console.error(err);
    });    
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>